import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IconButton, Drawer, List, ListItem, ListItemText, useMediaQuery, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ConnectButton from "./ConnectButton";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const toggleDrawer = (open) => setDrawerOpen(open);

  return (
    <nav className="navbar">
      <div className="navbar-title">
        <Link to="/" className="navbar-title-link">
          HLF<span className="navbar-subtitle">ilms</span>
        </Link>
      </div>
      {isMobile ? (
        <>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={() => toggleDrawer(true)}
            className="navbar-hamburger"
          >
            <MenuIcon className="navbar-menu-icon" />
          </IconButton>

          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => toggleDrawer(false)}
            className="navbar-drawer"
            BackdropProps={{
              sx: { backgroundColor: "rgba(255, 255, 255, 0.001)", backdropFilter: "blur(50px)" },
            }}
          >
            <Box className="drawer-container">
              <List>
                <ListItem button onClick={() => toggleDrawer(false)}>
                  <ListItemText primary={<Link to="/" className="drawer-link">Home</Link>} />
                </ListItem>
                <ListItem button onClick={() => toggleDrawer(false)}>
                  <ListItemText primary={<Link to="/about" className="drawer-link">About</Link>} />
                </ListItem>
                <ListItem button onClick={() => toggleDrawer(false)}>
                  <ListItemText primary={<Link to="/works" className="drawer-link">Works</Link>} />
                </ListItem>
                <ListItem button onClick={() => toggleDrawer(false)}>
                  <ListItemText primary={<Link to="/notes" className="drawer-link">Notes</Link>} />
                </ListItem>
                <ListItem button onClick={() => toggleDrawer(false)}>
                  <a href="https://calendly.com/higherlowfilms/30min" target="_blank" rel="noopener noreferrer" className="drawer-link">Connect</a>
                </ListItem>
              </List>
            </Box>
          </Drawer>
        </>
      ) : (
        <ul className="navbar-links">
          <li className="nav-item">
            <Link className="nav-a" to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-a" to="/about">About</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-a" to="/works">Works</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-a" to="/notes">Notes</Link>
          </li>
          <li className="nav-item">
            <ConnectButton />
          </li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
